import { render, staticRenderFns } from "./ServicesReservationAddedServiceReceipt.vue?vue&type=template&id=3896d0aa&scoped=true&"
import script from "./ServicesReservationAddedServiceReceipt.vue?vue&type=script&lang=js&"
export * from "./ServicesReservationAddedServiceReceipt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3896d0aa",
  null
  
)

export default component.exports